/* eslint-disable no-return-await */
/* eslint-disable class-methods-use-this */

import http from './httpService';

class AbpUserConfigurationService {
  async getAll() {
    return await http.get('/AbpUserConfiguration/GetAll');
  }

  async getAllCustom() {
    return await http.get('/AbpUserConfigurationCustom/GetAllCustom');
  }
}

export default AbpUserConfigurationService = new AbpUserConfigurationService();
